import { AITaskType } from '@constants/ai-assistant';

export const AI_KIND = {
    SERVICES: 'services',
    CATEGORIES: 'categories',
    SPECIAL_HOURS: 'specialHours',
    DESCRIPTION: 'description',
};

const DESCRIPTION_TASK = {
    shortDescription: AITaskType.GenerateGoogleLocationShortDescription,
    mediumDescription: AITaskType.GenerateGoogleLocationMediumDescription,
    longDescription: AITaskType.GenerateGoogleLocationDescription,
};

export const DESCRIPTION_FIELDS = Object.keys(DESCRIPTION_TASK);

export const descriptionTaskFor = field => DESCRIPTION_TASK[field];

export const aiKindFor = key => {
    if (DESCRIPTION_TASK[key]) return AI_KIND.DESCRIPTION;
    if (key === 'services') return AI_KIND.SERVICES;
    if (key === 'categories') return AI_KIND.CATEGORIES;
    if (key === 'specialHours') return AI_KIND.SPECIAL_HOURS;
    return null;
};

const capitalize = value => value.charAt(0).toUpperCase() + value.slice(1);

export const recommendationLabelKey = ({ key, variant }) =>
    `ScorePanel.rec.${key}${variant ? capitalize(variant) : ''}`;

export const draftedLabelKey = field => `ScorePanel.drafted.${field}`;
